import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { string } from 'prop-types';
import classnames from 'classnames';
import { FulfillmentPodShipping } from '@thd-olt-component-react/fulfillment';
import { ProductPodContext } from '../../ProductPodContext';

export const ProductShipping = ({ className }) => {
  const {
    isScheduleAMeasureEligible,
    product,
    storeId,
  } = useContext(ProductPodContext);

  if (isScheduleAMeasureEligible) return null;

  const { channel } = useContext(ExperienceContext);
  const shippingClasses = classnames(
    'product-pod__fulfillment--shipping',
    className, {
      'product-pod__fulfillment--shipping--mobile': channel === 'mobile'
    }
  );

  return (
    <div className={shippingClasses}>
      <FulfillmentPodShipping product={product} storeId={storeId} />
    </div>
  );
};

ProductShipping.propTypes = {
  className: string
};

ProductShipping.defaultProps = {
  className: null
};

ProductShipping.displayName = 'ProductShipping';
